export default function isEmpty(object) {
    for (const key in object) {
        if (object[key] != null && object[key] !== '') {
            return false;
        }
    }

    return true;
}